import { Badge } from "@/components/ui/badge";
import {
  AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { Shield } from "lucide-react";

export function CrmHistorySection({ company }) {
  if (!(company.crm_syncs || []).length) return null;
  return (
    <AccordionItem value="crm-history" className="border border-slate-200 rounded-lg shadow-sm overflow-hidden">
      <AccordionTrigger className="px-4 py-3 hover:no-underline hover:bg-slate-50 [&[data-state=open]]:bg-slate-50">
        <div className="flex items-center gap-2">
          <Shield className="w-4 h-4 text-slate-500" />
          <span className="text-sm font-semibold" style={{ fontFamily: 'Manrope, sans-serif' }}>CRM Sync History</span>
          <span className="text-[10px] text-muted-foreground ml-1">{company.crm_syncs.length} syncs</span>
        </div>
      </AccordionTrigger>
      <AccordionContent className="px-4">
        <div className="space-y-1">
          {company.crm_syncs.map((s, i) => (
            <div key={i} className="flex items-center justify-between p-2 rounded bg-slate-50 border border-slate-100 text-[11px]">
              <span className="font-medium capitalize">{s.platform}</span>
              <div className="flex items-center gap-2">
                <Badge variant="outline" className="text-[9px] bg-emerald-50 text-emerald-600 border-emerald-200 h-4">{s.status}</Badge>
                <span className="text-muted-foreground">{s.synced_at ? new Date(s.synced_at).toLocaleDateString() : "--"}</span>
              </div>
            </div>
          ))}
        </div>
        {company.crm_syncs.some(s => s.mock) && <p className="text-[9px] text-muted-foreground italic mt-1">Mock mode</p>}
      </AccordionContent>
    </AccordionItem>
  );
}
